import { useState, useEffect } from 'react';
import Link from 'next/link';
import {
  getDetailAd,
  IBannerAdRes,
} from '@/api/detail';
import { handleBannerAdResourceUrl } from '@/utils/url';
import CommonImage from '../CommonImage';
import Styles from './index.module.scss';

const BannerAd = () => {
  const [data, setData] = useState<IBannerAdRes | null>(null);

  useEffect(()=>{
    getDetailAd().then((res: IBannerAdRes) => {
      res && setData(res);
    })
  }, []);
  
  return data ?
    <Link className={Styles.root} href={data.url} target='_blank'>
      <CommonImage
        src={handleBannerAdResourceUrl(data.img)}
        isHeightAuto={true}
        cutMode='cover'
        width={316}
      />
    </Link> : null;
}

export default BannerAd;